/**
 * LINDIE Audio Player — lindie-audio-player.js
 * Handles PDP waveform animation, seek, time display.
 * NOTE: First-click URL fetch is handled by lindie-audio-preview.js.
 *       This file takes over once audio.src is set and audio is playing.
 */
(function () {
  'use strict';

  function formatTime(s) {
    if (!s || isNaN(s) || !isFinite(s)) return '0:00';
    var m = Math.floor(s / 60);
    var sec = Math.floor(s % 60);
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  function initPlayer(container) {
    var audio        = container.querySelector('.js-pdp-audio');
    var playBtn      = container.querySelector('.js-pdp-play');
    var waveform     = container.querySelector('.js-pdp-waveform');
    var currentTimeEl = container.querySelector('.js-pdp-current-time');
    var durationEl   = container.querySelector('.js-pdp-duration');

    if (!audio || !playBtn) return;

    var bars      = waveform ? Array.prototype.slice.call(waveform.querySelectorAll('.pdp-player__wave-bar')) : [];
    var totalBars = bars.length;

    var iconPlay    = playBtn.querySelector('.pdp-player__icon-play');
    var iconPause   = playBtn.querySelector('.pdp-player__icon-pause');
    var iconLoading = playBtn.querySelector('.pdp-player__icon-loading');

    /* ── Waveform progress ─────────────────────────────────────────────── */
    function updateWaveform() {
      if (!audio.duration) return;
      var pct = audio.currentTime / audio.duration;
      var activeBars = Math.floor(pct * totalBars);
      for (var i = 0; i < totalBars; i++) {
        bars[i].classList.toggle('pdp-player__wave-bar--active', i < activeBars);
      }
      if (currentTimeEl) currentTimeEl.textContent = formatTime(audio.currentTime);
    }

    function resetWaveform() {
      for (var i = 0; i < totalBars; i++) {
        bars[i].classList.remove('pdp-player__wave-bar--active');
      }
      if (currentTimeEl) currentTimeEl.textContent = '0:00';
    }

    function showPlayIcon()  {
      if (iconPlay)    iconPlay.style.display    = '';
      if (iconPause)   iconPause.style.display   = 'none';
      if (iconLoading) iconLoading.style.display = 'none';
      playBtn.disabled = false;
    }

    function showPauseIcon() {
      if (iconPlay)    iconPlay.style.display    = 'none';
      if (iconPause)   iconPause.style.display   = '';
      if (iconLoading) iconLoading.style.display = 'none';
      playBtn.disabled = false;
    }

    /* ── Play/Pause toggle — only active once audio.src is set ────────── */
    playBtn.addEventListener('click', function () {
      if (!audio.src || audio.src === window.location.href) return; /* not loaded yet — preview.js handles first click */
      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }
    });

    /* ── Waveform seek ──────────────────────────────────────────────────── */
    if (waveform) {
      waveform.addEventListener('click', function (e) {
        if (!audio.duration) return;
        var rect = waveform.getBoundingClientRect();
        var pct  = (e.clientX - rect.left) / rect.width;
        pct = Math.max(0, Math.min(1, pct));
        audio.currentTime = pct * audio.duration;
        updateWaveform();
      });
    }

    /* ── Audio events ────────────────────────────────────────────────────── */
    audio.addEventListener('play',  showPauseIcon);
    audio.addEventListener('pause', showPlayIcon);

    audio.addEventListener('loadedmetadata', function () {
      if (durationEl) durationEl.textContent = formatTime(audio.duration);
    });

    audio.addEventListener('timeupdate', updateWaveform);

    audio.addEventListener('ended', function () {
      showPlayIcon();
      resetWaveform();
      audio.currentTime = 0;
    });

    audio.addEventListener('error', function () {
      showPlayIcon();
      resetWaveform();
      console.error('LINDIE PDP audio error');
    });
  }

  /* Init on DOM ready */
  document.addEventListener('DOMContentLoaded', function () {
    var players = document.querySelectorAll('[data-audio-player]');
    for (var i = 0; i < players.length; i++) {
      initPlayer(players[i]);
    }
  });

  /* Re-init on Shopify theme editor section reload */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var players = e.target.querySelectorAll('[data-audio-player]');
      for (var i = 0; i < players.length; i++) {
        initPlayer(players[i]);
      }
    });
  }

})();
